import {useAlert} from '@contexts/hooks/useAlert.ts';
import {_fornecedor_endpoints} from '@components/fornecedores/endpoints/_fornecedor_endpoints.ts';
import {IFornecedor} from '@models/fornecedores/fornecedor.ts';
import {AddOutlined} from '@mui/icons-material';
import {Button, Grid, TextField} from '@mui/material';
import {CpfCnpjInput} from '@shared/custom/CpfCnpjInput.tsx';
import dayjs from 'dayjs';
import {useState} from 'react';
import {useApi} from "@contexts/hooks/api/useApi.ts";

export interface CreateFornecedorComponentProps {
	onCreate?: (f: IFornecedor) => void;
}

export const CreateFornecedorComponent: React.FC<CreateFornecedorComponentProps> = (props) => {
	const {Get} = useApi();
	const {createAlertFromResponse} = useAlert();
	const {CreateFornecedor} = _fornecedor_endpoints;
	const [fornecedor, setFornecedor] = useState<IFornecedor>({
		idErp: 0,
		nome: '',
		id: 0,
		dataCadastro: dayjs(),
		cpfCnpj: '',
		usuarioCriacaoId: 0,
	});
	
	const handleCreate = () => Get(CreateFornecedor(fornecedor)).then(x => {
		if (x.hasData) {
			if (props.onCreate) {
				props.onCreate(x.items);
			}
		}
		createAlertFromResponse(x);
	});
	
	
	return (
		<Grid container>
			<Grid size={12}>
				<Grid container justifyContent={'space-between'}>
					<Grid></Grid>
					<Grid><Button variant={'outlined'} endIcon={<AddOutlined/>}
					              onClick={handleCreate}>Criar</Button></Grid>
				</Grid>
			</Grid>
			<Grid size={12}>
				<CpfCnpjInput
					value={fornecedor.cpfCnpj ?? ''}
					slotProps={{
						TextField: {
							variant: 'outlined',
						},
					}}
					inputProps={{fullWidth: true}}
					onChange={(e) => {
						setFornecedor({...fornecedor, cpfCnpj: e});
					}}/>
			</Grid>
			<Grid size={12}>
				<TextField label={'Nome'}
				           fullWidth
				           value={fornecedor.nome} onChange={e => {
					setFornecedor({...fornecedor, nome: e.target.value});
				}}/>
			</Grid>
		</Grid>
	);
};